export default __webpack_public_path__ + "static/media/delete_icon.20ea3efa.svg";